// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__3CJOt","prevIcon":"styles_prevIcon__36GkU","nextIcon":"styles_nextIcon__U7sl-","listContainer":"styles_listContainer__3-0vY"};